<template>
  <div style="margin-bottom: 20px;">
    <div class="header-outer">
      <div class="container header-inner">
        <div :class="{'open' : showLanguageList}" class="language-selector">
          <span class="header-item language-item" @click="showLanguages">{{currentLanguage.value}}</span>
          <transition name="fade">
            <div class="language-list" v-show="showLanguageList">
              <div class="language-item" v-for="(language) in allLanguages" :key="language.key">
                <span @click="setLanguage(language)">{{language.value}}</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="logo-container">
      <div class="container">
        <a href="." @click="logoClicked">
          <img class="philips-logo" src="@/assets/img/philips-logo.png" alt="">
        </a>

      </div>
    </div>
  </div>
</template>

<script>
  import caretHeaderSvg from '@/assets/svg/caret-header.svg?inline';

  export default {
    name: "Header",
    data() {
      return {
        showLanguageList: false
      }
    },
    components: { caretHeaderSvg },

    computed: {
      isLoggedIn() {
        return this.$store.getters['auth/userLoggedIn'];
      },
      userExplicitlyProceedsWithoutLogin() {
        return this.$store.state.auth.userExplicitlyProceedsWithoutLogin;
      },
      currentLanguage() {
        return this.$store.getters["ui/currentLanguage"];
      },
      allLanguages() {
        return this.$store.getters["ui/availableLanguageData"];
      }
    },

    methods: {

      showLanguages() {
        this.showLanguageList = !this.showLanguageList;
      },

      setLanguage(language) {
        if (this.currentLanguage.key !== language.key) {
          const country = this.$store.state.search.country;
          this.$router.push({ query: {...this.$route.query, locale: language.key + "_" + country}});
          this.showLanguageList = false;
          this._i18n.locale = language.key;
          this.$store.commit('ui/currentLanguage', language.key);
          omniture.trackLanguage(language);
        }
      },
      checkLocale() {
        const query = this.$route.query.locale;
        let language;
        if (query && (language = this.allLanguages.find(l => l.key === query))) {
          this.setLanguage(language);
        }
      },
      logoClicked() {
        if(!this.$store.getters['auth/userMayProceed']) {
          this.$store.dispatch('auth/setUserExplicitlyProceedsWithoutLogin', true)
          .then(() => {
            this.$router.push({ name: 'home' });
          });
        }
      }
    },
    beforeMount(){
      this.checkLocale()
   },
  }
</script>

<style lang="scss">
  .philips-logo {
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.5);
    width: 98px;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .header-outer {
    background: $lightest-gray;
  }

  .header-inner {
    display: flex;
    justify-content: flex-end;
    position: relative;
  }

  .header-devider {
    height: 100%;
    border-left: 1px solid #e0e0e0;
  }

  .header-item {
    margin: 10px;
    color: $header-link-color;
    cursor: pointer;
  }

  a.header-item,
  span.header-item {

    &:hover {
      text-decoration: underline;
    }
  }

  .language-selector {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    position: relative;

    .language-list {
      position: absolute;
      top: 44px;
      border: 1px solid $border-color;
      padding: 5px;
      right: -5px;
      text-align: right;
      background: #FFF;
      z-index: 1;
     // max-height: 130px;
      overflow-y: auto;
    }

    .language-item {
      margin: 10px 5px;
      cursor: pointer;
      color: $header-link-color;

      &:hover {
        text-decoration: underline;
      }
    }

    .language-icon {
      height: 8px;
      margin: 18px 5px;
      transform: rotate(90deg);
      cursor: pointer;
      transition: ease 0.2s;
    }

    &.open .language-icon {
      transform: rotate(270deg);
      transition: ease 0.3s;
    }
  }
</style>
